/**
	!! AUTOGENERATED DO NOT EDIT !!
	by tools/scss-to-js-generator script 
*/
export default {
  'light-neutral-10': '#fdfcfd',
  'light-neutral-20': '#faf9fb',
  'light-neutral-30': '#f2eff3',
  'light-neutral-40': '#eae7ec',
  'light-neutral-50': '#e3dfe6',
  'light-neutral-60': '#dbd8e0',
  'light-neutral-70': '#d0cdd7',
  'light-neutral-80': '#bcbac7',
  'light-neutral-90': '#8e8c99',
  'light-neutral-100': '#84828e',
  'light-neutral-110': '#65636d',
  'light-neutral-120': '#211f26',
  'dark-neutral-10': '#121113',
  'dark-neutral-20': '#1a191b',
  'dark-neutral-30': '#232225',
  'dark-neutral-40': '#2b292d',
  'dark-neutral-50': '#323035',
  'dark-neutral-60': '#3c393f',
  'dark-neutral-70': '#49474e',
  'dark-neutral-80': '#625f69',
  'dark-neutral-90': '#6f6d78',
  'dark-neutral-100': '#7c7a85',
  'dark-neutral-110': '#b5b2bc',
  'dark-neutral-120': '#eeeef0',
  'light-primary-10': '#fefcfe',
  'light-primary-20': '#fbf7fe',
  'light-primary-30': '#f8f0fe',
  'light-primary-40': '#f2e4fc',
  'light-primary-50': '#ebd9f9',
  'light-primary-60': '#e3caf5',
  'light-primary-70': '#d8b6f0',
  'light-primary-80': '#c99fe6',
  'light-primary-90': '#7022a7',
  'light-primary-100': '#5f0f98',
  'light-primary-110': '#570791',
  'light-primary-120': '#39075b',
  'dark-primary-10': '#17111b',
  'dark-primary-20': '#1f1625',
  'dark-primary-30': '#2d1b3a',
  'dark-primary-40': '#3b224d',
  'dark-primary-50': '#47295c',
  'dark-primary-60': '#54346b',
  'dark-primary-70': '#674282',
  'dark-primary-80': '#8857ab',
  'dark-primary-90': '#954ec7',
  'dark-primary-100': '#a05cd1',
  'dark-primary-110': '#d69dff',
  'dark-primary-120': '#f2e0ff',
  'light-error-10': '#fffcfc',
  'light-error-20': '#fff7f7',
  'light-error-30': '#feebec',
  'light-error-40': '#ffdbdc',
  'light-error-50': '#ffcdce',
  'light-error-60': '#fdbdbe',
  'light-error-70': '#f4a9aa',
  'light-error-80': '#eb8e90',
  'light-error-90': '#e5484d',
  'light-error-100': '#dc3e42',
  'light-error-110': '#ce2c31',
  'light-error-120': '#641723',
  'dark-error-10': '#191111',
  'dark-error-20': '#201314',
  'dark-error-30': '#3b1219',
  'dark-error-40': '#500f1c',
  'dark-error-50': '#611623',
  'dark-error-60': '#72232d',
  'dark-error-70': '#8c333a',
  'dark-error-80': '#b54548',
  'dark-error-90': '#e5484d',
  'dark-error-100': '#ec5d5e',
  'dark-error-110': '#ff9592',
  'dark-error-120': '#ffd1d9',
  'light-warning-10': '#fefcfb',
  'light-warning-20': '#fff7ed',
  'light-warning-30': '#ffefd6',
  'light-warning-40': '#ffdfb5',
  'light-warning-50': '#ffd19a',
  'light-warning-60': '#ffc182',
  'light-warning-70': '#f5ae73',
  'light-warning-80': '#ec9455',
  'light-warning-90': '#f76b15',
  'light-warning-100': '#ef5f00',
  'light-warning-110': '#cc4e00',
  'light-warning-120': '#582d1d',
  'dark-warning-10': '#17120e',
  'dark-warning-20': '#1e160f',
  'dark-warning-30': '#331e0b',
  'dark-warning-40': '#462100',
  'dark-warning-50': '#562800',
  'dark-warning-60': '#66350c',
  'dark-warning-70': '#7e451d',
  'dark-warning-80': '#a35829',
  'dark-warning-90': '#f76b15',
  'dark-warning-100': '#ff801f',
  'dark-warning-110': '#ffa057',
  'dark-warning-120': '#ffe0c2',
  'light-success-10': '#fbfefc',
  'light-success-20': '#f4fbf6',
  'light-success-30': '#e6f6eb',
  'light-success-40': '#d6f1df',
  'light-success-50': '#c4e8d1',
  'light-success-60': '#adddc0',
  'light-success-70': '#8eceaa',
  'light-success-80': '#5bb98b',
  'light-success-90': '#30a46c',
  'light-success-100': '#2b9a66',
  'light-success-110': '#218358',
  'light-success-120': '#193b2d',
  'dark-success-10': '#0e1512',
  'dark-success-20': '#121b17',
  'dark-success-30': '#132d21',
  'dark-success-40': '#113b29',
  'dark-success-50': '#174933',
  'dark-success-60': '#20573e',
  'dark-success-70': '#28684a',
  'dark-success-80': '#2f7c57',
  'dark-success-90': '#30a46c',
  'dark-success-100': '#33b074',
  'dark-success-110': '#3dd68c',
  'dark-success-120': '#b1f1cb',
  'white-base': '#ffffff',
  'black-base': '#000000',
};
